module.exports = __webpack_public_path__ + "static/media/resolution.f5c772e0.svg";